import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder, createFakePostResponder } from '../../../test-utils';
import { createCustomCssApi, customCssApiRelativePath, customCssApiRelativePathV2, customCssApiValidationV2 } from './index';
export var createCustomCssApiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCustomCssApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetCustomCss: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + customCssApiRelativePath + (brandId ? "?brandId=" + brandId : ''));
        },
        whenUpdateCustomCss: function (dto) {
            return createFakePutResponder(fakeHttp, "" + customCssApiRelativePath)(dto.data);
        },
        whenGetCustomCssV2: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + customCssApiRelativePathV2 + (brandId ? "?brandId=" + brandId : ''));
        },
        whenUpdateCustomCssV2: function (dto) {
            return createFakePutResponder(fakeHttp, "" + customCssApiRelativePathV2)(dto.data);
        },
        whenValidateCustomCssV2: function (dto) {
            var defaultHost = dto === '*' ? '' : dto.tenantDefaultHost;
            var customCss = dto === '*' ? '' : dto.customCss;
            return createFakePostResponder(fakeHttp, "https://" + defaultHost + customCssApiValidationV2)({ customCss: customCss });
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map